export default __webpack_public_path__ + "static/media/presentation-border.de7e22da.svg";